var _commonsHelper = require('../commons/helper');
/**
 * Helper module for the Registration page
 */
module.exports = $.extend(_commonsHelper, {
	
	/**
	 * Remove the server side validation error messages
	 */
	removeValidationErrors: function(el) {
		$('ul.errors', el.parentNode).empty();		
	},
		
	/**
	 * get label of a form field
	 */
	getLabel: function(field) {
		return $.trim($(field).siblings('.form-label').text());
	}
});


//////////////////
// WEBPACK FOOTER
// ./src/main/ui/core/js/modules/registration/helper.js
// module id = 23
// module chunks = 4 7